/*=========================================================================================
  File Name: moduleNoteGetters.js
  Description: Note Module Getters
==========================================================================================*/
import CONSTANT from "@/utils/constant";

const getColorId = colorValue => {
	const matchedItem = CONSTANT.PICKER_COLORS.find(item => item.value === colorValue) || {};
	return matchedItem.id;
}

export default {
	getParsedNotes: state =>
		state.notes.map(note => ({
			...note,
			date: note.updated_at,
			colorId: getColorId(note.color),
			createdDate: note.created_at || null,
			updatedDate: note.updated_at || null
		})),
};
